import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AnalysisCard from './AnalysisCard'; // Adjust the import path as necessary
import fetchData from '../../utils/fetchData';
import { CircularProgress } from '@mui/material';
import ActionButtons from './ActionButtons'; // Adjust the import path as necessary
const AnalysisSection = ({
  selectedLob,
  setSecuredScore,
  setAppSummary,
  setAppStatus
}) => {
  const appData = useSelector(
    state => state.intakeData.selectedApplicationData
  );

  const [selectedApplicationData, setSelectedApplicationData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!appData?.application_id) return; // Check if application_id is available
    setLoading(true);
    fetchData(
      `https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v2/application_appetite?application_id=${appData?.application_id}`,
      'GET'
    )
      .then(data => {
        setSelectedApplicationData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching appetite data:', error);
        setLoading(false);
      });
  }, [appData]);

  useEffect(() => {
    calCulateTotalScore(selectedApplicationData);
    setAppSummary(selectedApplicationData?.[selectedLob]?.Summary?.['Summary']);
    setAppStatus(
      selectedApplicationData?.[selectedLob]?.Summary?.['FinalStatus']
    );
  }, [selectedApplicationData]);

  const calCulateTotalScore = data => {
    const lobData = data?.[selectedLob]?.['Summary'] || {};

    setSecuredScore(lobData.score);
  };

  const cardTypes = [
    'Do Not Write',
    'Comments And Guidance',
    'Desk Manual Guidance'
  ];

  const enrichedData = {
    ...selectedApplicationData?.[selectedLob],
    ...cardTypes.reduce((acc, type) => {
      if (!selectedApplicationData?.[selectedLob]?.[type]) {
        acc[type] = {};
      }
      return acc;
    }, {})
  };

  const displayedCardTypes = cardTypes; // Ensure the order is always maintained

  return (
    <>
      {selectedLob && (
        <section
          className='flex flex-col px-4 mt-0 w-full py-3 max-md:px-5 max-md:py-24 max-md:mt-0 max-md:max-w-full'
          style={{ paddingRight: '0' }}
        >
          {loading ? (
            <div className='flex justify-center items-center w-full h-full'>
              <CircularProgress color='warning' />
            </div>
          ) : (
            <>
              <div className='flex gap-5 appetite-stages justify-center'>
                {displayedCardTypes.map(
                  type =>
                    type !== 'Summary' && (
                      <AnalysisCard
                        key={type}
                        cardData={enrichedData[type]}
                        cardType={type}
                        selectedLob={selectedLob}
                      />
                    )
                )}
              </div>
              <div className='flex justify-center mt-12'>
                <ActionButtons />
              </div>
            </>
          )}
        </section>
      )}
    </>
  );
};

export default AnalysisSection;
